import { FC } from "react";
import { InnerBox } from "@/components/elements/InnerBox";
import { Grid } from "@mui/material";
import { findLabelByValue } from "@/utils/object";
import { useEnum } from "@/api/services/global/enum";
import { TGetCompanyDto } from "@/api/services/admin/company/dtos/get-company.dto";
import { ItemInfo } from "@/components/commons/ItemInfo";
import { BillingCountInfo, NO_PADDING_GRID_ITEM } from "@/components/commons/BillingCountInfo";

type TCompanyBasicInfoDetailProps = {
  company: TGetCompanyDto;
};

export const CompanyBasicInfoDetail: FC<TCompanyBasicInfoDetailProps> = ({ company }) => {
  const { data: contractStatusOptions } = useEnum("ERSOContractStatus");

  return (
    <InnerBox title="契約情報" padding={3}>
      <Grid container spacing={2}>
        <Grid item xs={3}>
          <ItemInfo label="ステータス" value={findLabelByValue(contractStatusOptions, company.contractStatus)} />
        </Grid>
        <Grid item xs={3}>
          <ItemInfo label="契約プラン" value={company?.contractPlan} />
        </Grid>
        <Grid item xs={3} sx={NO_PADDING_GRID_ITEM}>
          <BillingCountInfo label="最大課金対象数" count={company?.currentMonthBillingCount} date={company?.currentMonthBillingCountDate} />
        </Grid>
        <Grid item xs={3} sx={NO_PADDING_GRID_ITEM}>
          <BillingCountInfo label="前回課金対象数" count={company?.previousMonthBillingCount} date={company?.previousMonthBillingCountDate} />
        </Grid>
        <Grid item xs={3}>
          <ItemInfo label="トライアル開始日" value={company?.trialStartDate} type="date" />
        </Grid>
        <Grid item xs={3}>
          <ItemInfo label="トライアル終了日" value={company?.trialEndDate} type="date" />
        </Grid>
        <Grid item xs={3}>
          <ItemInfo label="契約日" value={company?.contractStartDate} type="date" />
        </Grid>
        <Grid item xs={3}>
          <ItemInfo label="解約日" value={company?.contractEndDate} type="date" />
        </Grid>
      </Grid>
    </InnerBox>
  );
};
